type Props = { rank: number; top: boolean };

export const RankCell: React.FC<Props> = ({ rank, top }) => {
  if (top && rank <= 3) {
    return (
      <span className="w-[24px] flex-none text-center text-[18px] leading-none">
        {rank === 1 ? "🥇" : rank === 2 ? "🥈" : "🥉"}
      </span>
    );
  }

  return (
    <span className="text-grey4 w-[24px] flex-none text-center text-[14px] leading-none font-bold">
      {rank}
    </span>
  );
};
